"use client";

import Link from "next/link";
import Image from "next/image";
import { Github, Twitter, Linkedin, Mail, LocateIcon, MapIcon, MapPin, Facebook, Instagram } from "lucide-react";
import { MapMode } from "@codemirror/state";

export default function Footer() {
    return (
        <footer className="relative py-12 px-6 border-t border-gray-100 dark:border-white/5 bg-white dark:bg-gray-950 overflow-hidden">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    {/* Logo & Description */}
                    <div className="md:col-span-1 space-y-6">
                        <Link href="/" className="flex items-center gap-2">
                            <Image
                                src="/images/svg_logo/icomm_Logo_01.svg"
                                alt="iComm Logo"
                                width={120}
                                height={40}
                                className="block dark:hidden"
                            />
                            <Image
                                src="/images/svg_logo/icomm_Logo_04.svg"
                                alt="iComm Logo"
                                width={120}
                                height={40}
                                className="hidden dark:block"
                            />
                        </Link>
                        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed max-w-xs">
                            The ultimate email campaign platform for high-growth teams.
                            Built for deliverability, speed, and real-time visibility.
                        </p>
                        <div className="flex items-center gap-4">
                            <button className="p-2 rounded-lg bg-gray-100 dark:bg-white/5 text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors" >
                                <Link href="https://www.facebook.com" target="_blank">
                                    <Facebook className="h-4 w-4" />
                                </Link>
                            </button>
                            <button className="p-2 rounded-lg bg-gray-100 dark:bg-white/5 text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors" >
                                <Link href="https://www.linkedin.com" target="_blank">
                                    <Linkedin className="h-4 w-4" />
                                </Link>
                            </button>
                            {/* <button className="p-2 rounded-lg bg-gray-100 dark:bg-white/5 text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">
                                <Instagram className="h-4 w-4" />
                            </button> */}
                        </div>
                    </div>

                    {/* Links */}
                    <div className="md:col-span-3 grid grid-cols-2 sm:grid-cols-3 gap-8">
                        <div className="space-y-4">
                            <h4 className="text-sm font-black text-gray-900 dark:text-white uppercase tracking-widest">Platform</h4>
                            <ul className="space-y-3">
                                <li><Link href="/campaigns" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Campaigns</Link></li>
                                <li><Link href="/contacts" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Contacts</Link></li>
                                <li><Link href="/templates" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Templates</Link></li>
                                <li><Link href="/analysis" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Analytics</Link></li>
                            </ul>
                        </div>
                        <div className="space-y-4">
                            <h4 className="text-sm font-black text-gray-900 dark:text-white uppercase tracking-widest">Company</h4>
                            <ul className="space-y-3">
                                <li><Link href="#" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">About Us</Link></li>
                                <li><Link href="#" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Privacy Policy</Link></li>
                                <li><Link href="#" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Terms of Service</Link></li>
                                <li><Link href="#" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Cookie Policy</Link></li>
                            </ul>
                        </div>
                        <div className="space-y-4 col-span-2 sm:col-span-1">
                            <h4 className="text-sm font-black text-gray-900 dark:text-white uppercase tracking-widest">Help</h4>
                            <ul className="space-y-3">
                                <li><Link href="#" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Support Center</Link></li>
                                <li><Link href="#" className="text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Documentation</Link></li>
                                <li className="flex items-center gap-2 group cursor-pointer">
                                    <div className="p-2 rounded-lg bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 group-hover:bg-indigo-500 group-hover:text-white transition-all">
                                        <Mail className="h-4 w-4" />
                                    </div>
                                    <span className="text-xs font-bold text-gray-900 dark:text-white">info@bigtek.ai</span>
                                </li>
                                <li className="flex items-center gap-2 group cursor-pointer">
                                    <div className="p-2 rounded-lg bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 group-hover:bg-indigo-500 group-hover:text-white transition-all">
                                        <MapPin className="h-4 w-4" />
                                    </div>
                                    <span className="text-xs font-bold text-gray-900 dark:text-white">30 N Gould St Ste 5690,<br /> Sheridan WY 82801,<br /> 209-583-7198</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="pt-8 border-t border-gray-100 dark:border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-gray-400 dark:text-gray-600 font-medium">
                        © 2026 BigTek LLC. All rights reserved.
                    </p>
                    <div className="flex items-center gap-6">
                        <span className="flex items-center gap-1.5 text-[10px] font-black text-emerald-500 uppercase tracking-widest">
                            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                            System Operational
                        </span>
                    </div>
                </div>
            </div>

            {/* Decorative background circle */}
            <div className="absolute top-1/2 left-0 w-96 h-96 rounded-full bg-indigo-500/5 blur-3xl -translate-x-1/2 -translate-y-1/2 -z-10" />
        </footer>
    );
}
